export const docs = {
  brandbook: '/docs/brandbook.pdf',
  brandbookGeRu: '/docs/brandbook-geRu.pdf',
  brandbookGeGe: '/docs/brandbook-geGe.pdf',
  brandbookSimplified: '/docs/brandbookSimplified.pdf',
  instruction: '/docs/Инструкция открытия.pdf',
  ecobox: 'https://point.wb.ru/assets/files/ecoplatform_offer.pdf',
  elock_DJ05FY: '/docs/DJ05FY-User-Manual.pdf',
  privacyPolicy: 'https://point.wb.ru/docs/terms/index.html',
  requirementsVideoServiceIntegration: '/docs/Требования_к_интеграции_видеосервисов.docx',
  checklist: '/docs/checklist.pdf',
  technicalDescriptionOfEquipment: '/docs/point_pickpoint_furniture_drawings.pdf',

}

export const staticDocs = {
  fastDelivery: 'https://static-basket-05.wbbasket.ru/vol115/extdelivery/promo/Bystraya_dostavka_A1.pdf',
  wildberries1:
    'https://static-basket-05.wbbasket.ru/vol115/extdelivery/promo/Vajldberriz_delaet_zhizn_proshche_1200_2700.pdf',
  wildberries2:
    'https://static-basket-05.wbbasket.ru/vol115/extdelivery/promo/Vajldberriz_put_v_mir_mody_1200_2700.pdf',
  wildberries3:
    'https://static-basket-05.wbbasket.ru/vol115/extdelivery/promo/Vajldberriz_stil_vashej_zhizni_1200_2700.pdf',
  video: 'https://static-basket-05.wbbasket.ru/vol115/extdelivery/promo/Vedyom_videonablyudenie.pdf',
  door1: 'https://static-basket-05.wbbasket.ru/vol115/extdelivery/promo/Dver_na_sebya.pdf',
  foor2: 'https://static-basket-05.wbbasket.ru/vol115/extdelivery/promo/Dver_ot_sebya.pdf',
  pickUp: 'https://static-basket-05.wbbasket.ru/vol115/extdelivery/promo/Zdes_mozhno_poluchit_zakazy_A4.pdf',
  instagramQR: 'https://static-basket-05.wbbasket.ru/vol115/extdelivery/promo/Otmechaj_nas_v_Instagram_QR.pdf',
  vibes1: 'https://static-basket-05.wbbasket.ru/vol115/extdelivery/promo/Podelis_momentami_1_A1.pdf',
  vibes2: 'https://static-basket-05.wbbasket.ru/vol115/extdelivery/promo/Podelis_momentami_2_A1.pdf',
  disounts: 'https://static-basket-05.wbbasket.ru/vol115/extdelivery/promo/Skidki_i_akcii_kazhdyj_den.pdf',
  opening1: 'https://static-basket-05.wbbasket.ru/vol115/extdelivery/promo/Skoro_otkrytie_1189x841.pdf',
  opening2: 'https://static-basket-05.wbbasket.ru/vol115/extdelivery/promo/Skoro_otkrytie_594h420.pdf',
  benefits1: 'https://static-basket-05.wbbasket.ru/vol115/extdelivery/promo/Udobnyj_samovyvoz_A1.pdf',
  benefits2: 'https://photos.wbstatic.net/point/promo/Флаер_рядом_с_вами_партнёрский_пункт_самовывоза.ai',
  benefits3: 'https://photos.wbstatic.net/point/promo/Широкий_асортимент_А1.pdf',
}
